import request from '@/utils/request';

/**
 * 本文件由code-generator根据yapi文档自动生成
 */

export type IloginUsernamePasswordRestenantChannelInfoVOListInterFace = {
  thumbnail?: string;

  tenantName?: string;

  tenantId?: string;

  channelName?: string;

  channelId?: number;
};

/**
 * 账号密码-登录
 */

export type loginUsernamePasswordRes = {
  userInfoVO: {
    xagAccountGuid?: string;

    userStatus?: string;

    mail?: string;

    mobile?: string;

    updateTime?: number;

    uuid?: string;

    realName?: string;

    deleted?: boolean;

    createTime?: number;

    xaToken?: string;

    name?: string;

    id?: number;

    xagRefreshToken?: string;
  };

  tenantChannelInfoVOList?: IloginUsernamePasswordRestenantChannelInfoVOListInterFace[];
};

export type loginUsernamePasswordReq = {
  username: string;

  password: string;
};

export function loginUsernamePassword(
  data: loginUsernamePasswordReq
): Promise<loginUsernamePasswordRes> {
  return request.post('/base/login/usernamePassword', data);
}

/**
 * 退出登录
 */

export type logoutRes = {
  status: string; // 响应码，200正常，其他异常

  message: string;
};

export function logout(): Promise<logoutRes> {
  return request.get('/base/logout');
}

/**
 * 获取手机验证码
 */

export type noVerifyGetMobileVerifyCodeRes = {
  message?: string;

  status?: number;
  data?: {
    verifyCode: string;
  };
};

export type noVerifyGetMobileVerifyCodeReq = {
  mobile: string;
};

export function noVerifyGetMobileVerifyCode(
  data: noVerifyGetMobileVerifyCodeReq
): Promise<noVerifyGetMobileVerifyCodeRes> {
  return request.get('/base/noVerify/getMobileVerifyCode', {
    params: data,
  });
}

/**
 * 手机号验证码-登录
 */

export type loginSmsRes = {
  tenantChannelInfoVOList?: IloginUsernamePasswordRestenantChannelInfoVOListInterFace[];
  userInfoVO: {
    createTime?: string;
    xaToken: string;

    deleted?: boolean;

    id?: number; // 用户ID

    mobile?: string; // 手机号

    name?: string; // 用户名称

    realName?: string; // 用户实名

    updateTime?: string;

    userStatus?: number; // 账号状态

    uuid?: string; // 用户UUID

    xagAccountGuid?: string; // 账号中心的guid
  };

  message?: string;

  status?: number;
};

export type loginSmsReq = {
  mobile: string;

  verifyCode: string;
};

export function loginSms(data: loginSmsReq): Promise<loginSmsRes> {
  return request.get('/base/login/sms', {
    params: data,
  });
}

/**
 * 手机号验证码注册-(也可登录)
 */

export type loginRegisterLoginSmsRes = {
  data: {
    userInfoVO: {
      createTime?: string;

      deleted?: boolean;

      id?: number;

      mobile?: string;

      name?: string;

      realName?: string;

      updateTime?: string;

      userStatus?: number;

      uuid?: string;

      xagAccountGuid?: string;
    };
  };

  message?: string;

  status?: number;
};

export type loginRegisterLoginSmsReq = {
  name?: string;

  phone?: string;

  verifyCode?: string;

  password?: string;
};

export function loginRegisterLoginSms(
  data: loginRegisterLoginSmsReq
): Promise<loginRegisterLoginSmsRes> {
  return request.post('/base/login/registerLoginSms', data);
}

/**
 * 校验当前手机号是否已注册
 */

export type noVerifyAccountExistByMobileRes = {
  status?: number;

  message?: string;
};

export type noVerifyAccountExistByMobileReq = {
  mobile: string;
};

export function noVerifyAccountExistByMobile(
  data: noVerifyAccountExistByMobileReq
): Promise<noVerifyAccountExistByMobileRes> {
  return request.get('/base/noVerify/accountExistByMobile', {
    params: data,
  });
}

/**
 * 校验渠道有效性
 */

export type channelCheckChannelRes = {
  data: {
    orgIds?: string;

    tanantId?: string;

    scope?: number;

    channelId?: number;
  };

  message?: string;

  status?: number;
};

export type channelCheckChannelReq = {
  channelId: number;

  tenantId: string;
};

export function channelCheckChannel(
  data: channelCheckChannelReq
): Promise<channelCheckChannelRes> {
  return request.post('/base/channel/checkChannel', data);
}

/**
 * 重置密码(通过手机验证码)
 */

export type noVerifyResetPasswordRes = {
  status: number;

  message?: string;
};

export type noVerifyResetPasswordReq = {
  mobile?: string;

  verifyCode?: string;

  password?: string;
};

export function noVerifyResetPassword(
  data: noVerifyResetPasswordReq
): Promise<noVerifyResetPasswordRes> {
  return request.post('/base/noVerify/resetPassword', data);
}
